import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  toggleMenu() {
    $('#wrap-up-share-menu').toggle();
  }
}
